import { PortalPermissionsAdminSettings } from "@features/portal-administration/components/PortalPermissionsAdminSettings";
import { meSessionQueryOptions } from "@features/me/queries";
import { canAccessPortalAdministration } from "@features/portal-administration/access";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/admin/permissions")({
    beforeLoad: async ({ context }) => {
        const session = await context.queryClient.ensureQueryData(meSessionQueryOptions());
        const actualRoles = session.actualStaffProfile?.roles.map((role) => role.code) ?? [];

        if (!canAccessPortalAdministration(actualRoles)) {
            throw redirect({ to: "/home" });
        }
    },
    component: RouteComponent,
});

function RouteComponent() {
    return <PortalPermissionsAdminSettings />;
}
